import { Dayjs } from 'dayjs';

import { useCreateCourtBookingMutation } from '../store/Api';
import { CreateCourtBookingForm } from '../store/types';

type FormData = CreateCourtBookingForm

interface Props {
  bookingStartTime?: Dayjs;
  courtId?: number;
}

export function useCreateBooking({ bookingStartTime, courtId }: Props) {
  const [create, { isSuccess, isError, isLoading, error }] = useCreateCourtBookingMutation();

  const createBooking = ({ endTime, repeatUntil, extraOptions, ...values }: FormData) => {
    if (bookingStartTime === undefined || courtId === undefined) {
      return;
    }
    create({
      ...values,
      courtId,
      startTime: bookingStartTime.format('YYYY-MM-DDTHH:mm'),
      endTime: endTime.format('YYYY-MM-DDTHH:mm'),
      ...(repeatUntil !== undefined && { repeatUntil: repeatUntil.format('YYYY-MM-DD') }),
      ...(extraOptions !== undefined && { extraOptions: extraOptions }),
    });
  };

  return ({
    isSuccess, isError, isLoading, createBooking, error
  });
}
